module.exports = {
  "zones": {
    "Pacific/Enderbury": ["z", {
      "wallclock": 788832000000,
      "format": "+13",
      "abbrev": "+13",
      "offset": 46800000,
      "posix": 788871600000,
      "save": 0
    }, {
      "wallclock": 307584000000,
      "format": "-11",
      "abbrev": "-11",
      "offset": -39600000,
      "posix": 307627200000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "-12",
      "abbrev": "-12",
      "offset": -43200000,
      "posix": -2177411740000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -41060000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};